export default "__VITE_ASSET__678fd8a0__"